import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Download } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section id="precio" className="py-24 px-6 bg-brand-beige text-center" data-id="element-44">
      <div className="max-w-4xl mx-auto" data-id="element-45">
        <FadeIn data-id="element-46">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-brown mb-10 leading-tight" data-id="element-47">
            Merece Caminar Sin Miedo.
            <br data-id="element-48" />
            Empiece Hoy.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-49">
          <div className="flex flex-col items-center mb-10" data-id="element-50">
            <div className="mb-6" data-id="element-51">
              <span className="text-lg text-brand-dark line-through opacity-60 mr-3" data-id="element-52">
                $19.99
              </span>
              <span className="text-4xl md:text-5xl font-serif font-bold text-brand-terracotta" data-id="element-53">
                $6.39
              </span>
            </div>
            <Button className="text-xl md:text-2xl py-5 px-12" onClick={() => {
            trackAddToCart({
              content_name: 'Rodillas Sin Dolor',
              value: 6.39,
              currency: 'USD'
            });
            window.open('https://www.rumbosaludable.com/cart/46577378361534:1', '_blank');
          }} data-id="element-54">
              ¡Descargar Mi Guía Ahora!
            </Button>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-55">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-brand-dark opacity-80 text-base md:text-lg" data-id="element-56">
            <div className="flex items-center gap-2" data-id="element-57">
              <Download className="w-5 h-5" data-id="element-58" />
              <span data-id="element-59">Descarga inmediata</span>
            </div>
            <div className="hidden md:block w-1.5 h-1.5 bg-brand-dark rounded-full" data-id="element-60"></div>
            <div className="flex items-center gap-2" data-id="element-61">
              <span className="font-serif italic" data-id="element-62">PDF fácil de leer</span>
            </div>
            <div className="hidden md:block w-1.5 h-1.5 bg-brand-dark rounded-full" data-id="element-63"></div>
            <div className="flex items-center gap-2" data-id="element-64">
              <span data-id="element-65">Resultados desde el día 1</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}